import React, { useEffect, useRef } from "react";
import cancelIcon from "../../../assets/images/cancel.png"; // ✅ Import your icon
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";
export default function CancelPreApprovedModal({
  isOpen,
  onClose,
  onConfirm,
  logoSrc,
}) {
  const modalRef = useRef();

  useLockBodyScroll(isOpen);

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div
        ref={modalRef}
        className="bg-white rounded-xl shadow-lg p-6 w-72 relative"
      >
        <div className="relative mb-4">
          {/* Heading centered */}
          <h2 className="text-center text-lg font-semibold">
            Cancel Pre-Approved
          </h2>

          {/* Cancel icon absolutely positioned on the right */}
          <img
            src={cancelIcon}
            alt="Cancel"
            onClick={onClose}
            className="absolute top-0 right-0 w-6 h-6 cursor-pointer hover:scale-110 transition"
          />
        </div>

        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img
            src={logoSrc}
            alt="Company"
            className="w-28 h-20 object-contain rounded border"
          />
        </div>

        {/* Cancel Button */}
        <button
          onClick={onConfirm}
          className="w-full py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition"
        >
          Cancel Pre-Approved
        </button>
      </div>
    </div>
  );
}
